export default __webpack_public_path__ + "static/media/arrow.45185c1d.png";